import React, { FC, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import styles from "./footer.module.scss";
import useRWD from "../../hooks/useRWD";
import { DeviceType } from "../../hooks/useRWD";

const FooterLayout: FC = () => {
  const device = useRWD()
  const footerList: any[] = [
    {
      moduleName: "認識我們",
      url: "",
    },
    {
      moduleName: "關於我們",
      url: "about-us",
    },
    {
      moduleName: "大創綠能",
      url: "",
    },
    {
      moduleName: "挺綠電",
      url: "",
    },
    {
      moduleName: "加入我們",
      url: "seller",
    },
    {
      moduleName: "如何購電",
      url: "know-how",
    },
    {
      moduleName: "Q&A",
      url: "faq",
    },
    {
      moduleName: "我有需求",
      url: "",
    },
  ];

  const renderFooterLinks = (startIndex: number, endIndex: number) => {
    return footerList.slice(startIndex, endIndex).map((item, index) => (
      <li key={index}>
        {item.moduleName === "認識我們" || item.moduleName === "挺綠電" ? (
          // 如果是"認識我們"或"挺綠電"，顯示純文字
          <div className={`item ${styles.largeFont}`} >
            {item.moduleName}
          </div>
        ) : (
          // 否則顯示帶超連結的內容
          <NavLink to={`${item.url}`}>
            <div className={`item `}>
              {item.moduleName}
            </div>
          </NavLink>
        )}
      </li>
    ));
  };

  const [containerClass, setContainerClass] = useState('container');

  const handleResize = () => {

    if (window.innerWidth < 992) {
      setContainerClass('container-fluid');
    } else {
      setContainerClass('container');
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <footer className={styles['footer_box']}>
      <div className="content_box">
        <div className={containerClass}>
          <div className="row">
            <div className="col-lg-4 col-md-4  col-sm-12 content_sec">

              {device === DeviceType.PC && (
                <div className="logo_box">
                  <img className="logoIMG" src="/assets/images/logo/white-logo.png" alt="logo" />
                  {/* <div className="logo_title">大創電力</div> */}
                </div>
              )}

              <div className="contact_rwd_box">
                <div className="contact_box">
                  <img className="contact_icon" src="/assets/images/footer/house.svg" alt="" />
                  <div className="contact_text">
                    {device !== DeviceType.PC ? "聯繫地址" : "82065高雄市岡山區中山南路308號1樓"}
                  </div>
                </div>

                {device !== DeviceType.PC && (
                  <div className="contact_box">
                    <div className="contact_text">82065高雄市岡山區中山南路308號1樓</div>
                  </div>
                )}
              </div>

              <div className="contact_rwd_box">
                <div className="contact_box">
                  <img className="contact_icon" src="/assets/images/footer/phone.svg" alt="" />
                  <div className="contact_text">
                    {device !== DeviceType.PC ? "官方客服" : "07-622-8422"}
                  </div>
                </div>
                {device !== DeviceType.PC && (
                  <div className="contact_box">
                    <div className="contact_text">07-622-8422</div>
                  </div>
                )}
              </div>


              <div className="contact_rwd_box">
                <div className="contact_box">
                  <img className="contact_icon" src="/assets/images/footer/email.svg" alt="" />
                  <div className="contact_text">
                    {device !== DeviceType.PC ? "聯繫信箱" : "service@da-chuang.tw"}
                  </div>
                </div>

                {device !== DeviceType.PC && (
                  <div className="contact_box">
                    <div className="contact_text">service@da-chuang.tw</div>
                  </div>
                )}
              </div>
            </div>


            {device === DeviceType.PC && (
              <div className="col-4 content_sec middle">
                <div className="footer_links_box_v2">
                  <div className="title">認識我們</div>
                  <div className="links_box">
                    <NavLink to="/about-us" className="links">關於我們</NavLink>
                    <a href="https://www.da-chuang.tw/" target="_blank" rel="noopener noreferrer" className="links">大創綠能</a>
                    <NavLink to="/home#contactUs" className="links">聯絡大創</NavLink>
                  </div>
                </div>

                <div className="footer_links_box_v2">
                  <div className="title">挺綠電</div>
                  <div className="links_container">
                    <div className="links_box">
                      <a href="/buyer" className="links">註冊買家</a>
                      <a href="/seller" className="links">註冊賣家</a>
                      <NavLink to="/know-how" className="links">如何購電</NavLink>
                    </div>
                    <div className="links_box">
                      <a href="/trading" className="links" >多元化交易</a>
                      <a href="/faq" className="links">Q&A</a>
                      <a href="/public-information" className="links">公開資訊</a>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* {device === DeviceType.PC && (
              <div className="col-4 content_sec">
                <ul className="footer_links_box">
                  <div className="footer_links">
                    {renderFooterLinks(0, 3)}</div>
                  <div className="footer_links">
                    {renderFooterLinks(3, 6)}</div>
                  <div className="footer_links">
                    {renderFooterLinks(6, 8)}</div>
                </ul>
              </div>
            )} */}

            <div className="col-lg-4 col-md-4  col-sm-12 content_sec">
              <div className="copy_right_box">
                <div className="copy_right_links">
                  <a className="with_border" href="/copy-right/copyright.html" target="_blank" rel="noopener noreferrer">
                    智慧財產聲明政策
                  </a>
                  <a href="/copy-right/privacy.html" target="_blank" rel="noopener noreferrer">
                    隱私權政策
                  </a>
                </div>
                <div className="copy_right_text">Copyright © 2024 大創電力股份有限公司著作權所有</div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterLayout;